<template>
  <div class="inspectionReport">
    <div class="inspectionContent">
      <!-- <div class="dataTitle">
        <van-icon
          class="hospiyalsArrowLeft"
          style="top: 16px;"
          name="arrow-left"
          @click="onBack"
          v-if="forwardingReport"
        />
        <div class="title">
          <div class="content action">检查报告</div>
          <div class="line">|</div>
      <div class="content" @click="toPortrait">数字影像</div>-->
      <!-- <div class="line" v-if="forwardingReport&&examId">|</div>
      <div class="content" @click="toForwarding" v-if="forwardingReport&&examId">转发报告</div>-->
      <!-- </div>
      </div>-->
      <div class="reportLoading" v-if="loading">
        <van-loading size="24px" vertical>报告加载中...</van-loading>
      </div>
      <div class="dataList" v-else-if="report">
        <div class="itemContent" v-for="(item,index) in infoData" :key="index">
          <ul class="info">
            <li class="header">
              <span v-if="item.type == 1">{{item.local_institution_name}}</span>
              <span v-if="item.type == 2">{{item.remote_institution_name}}</span>
              <span :id="`qrcode${index}`" class="white_QR"></span>
            </li>
            <li class="labelContent">
              <span class="label1">影像号：</span>
              <span class="content1">{{item.accession_num}}</span>
              <span class="label2">姓名：</span>
              <span class="content2">{{item.name}}</span>
            </li>
            <li class="labelContent">
              <span class="label1">检查时间：</span>
              <span class="content1">{{item.exam_datetime}}</span>
              <span class="label2">性别：</span>
              <span class="content2" v-if="item.sex == 'M'||item.sex == '男'">男</span>
              <span class="content2" v-if="item.sex == 'F'||item.sex == '女'">女</span>
            </li>
            <li class="labelContent">
              <span class="label1">申请科室：</span>
              <span class="content1">{{item.application_department}}</span>
              <span class="label2">年龄：</span>
              <span class="content2">{{item.age}}</span>
              
            </li>
            <li class="labelContent" v-if="item.institution_id ==='06300007'">
              <span class="label1">年龄：</span>
              <span class="content1">{{item.age}}</span>
              <span class="label2">申请科室：</span>
              <span class="content2">{{item.application_department}}</span>
            </li>
            <li class="labelContent" v-if="item.institution_id ==='06300007'">
              <span class="label1">住院号：</span>
              <span class="content1">{{item.hopitalized_no}}</span>
              <span class="label2">床号：</span>
              <span class="content2">{{item.bed_no}}</span>
            </li>
            <li class="labelContent" v-if="item.institution_id ==='06300007'">
              <span class="label1">检查部位：</span>
              <span class="content1" style="width:80%;text-align-last: auto;">{{item.exam_project}}</span>
            </li>
            <li class="labelContent" v-if="item.config_number&&item.insConfig">
              <!-- style="width:80%;text-align-last: auto;" -->
              <span class="label1">{{item.insConfig}}：</span>
              <span class="content1">{{item.config_number}}</span>
            </li> 
            <li class="labelContents" style="min-height:25px;" v-if="item.institution_id ==='83000004'">
              <!-- style="width:80%;text-align-last: auto;" -->
              <span class="label1">检查号：</span>
              <span class="content1" style="width:100%;text-align-last: auto;word-wrap: break-word;">{{item.his_patient_id}}</span>
            </li>
            <li class="labelContents" style="min-height:25px;">
              <!-- style="width:80%;text-align-last: auto;" -->
              <span class="label1">检查项目：</span>
              <span class="content1" style="width:100%;text-align-last: auto;word-wrap: break-word;">{{item.exam_project}}</span>
            </li>
            
            <li class="details">
              <div class="label" v-if="item.institution_id ==='06300007'">影像学所见：</div>
              <div class="label" v-else>检查所见：</div>
              <div class="details_info">
                <span v-html="item.description"></span>
              </div>
              <div class="label" v-if="item.institution_id ==='06300007'">影像学意见：</div>
              <div class="label" v-else>诊断意见：</div>
              <div class="details_info">
                <span v-html="item.impression"></span>
              </div>
            </li>
            <li class="food">
              <span class="label">报告:</span>
              <span class="content">{{item.report_doctor_name}}</span>
              <span class="label">审核:</span>
              <span class="content">{{item.review_doctor_name}}</span>
              <span class="label" v-if="item.institution_id !=='73000005'">确认:</span>
              <span class="content" v-if="item.institution_id !=='73000005'">{{item.confirm_doctor_name}}</span>
            </li>
          </ul>
          <div class="reportDate">
            <span>报告时间:{{item.report_datetime}}</span>
          </div>
        </div>
      </div>
      <div v-else-if="errorMessage" class="white_title">{{errorMessage}}</div>
      <div v-else-if="!awaitingPassword" class="white_title">暂无报告</div>
      <div
        class="allReport"
        @click="toReportList"
        v-if="Storage.get('reportPermissions') != 1"
          >< 全部报告</div>
      <footer class="footer" v-if="noreport">
          <!-- <div class="outreach" @click="insurance">
            医疗保险
            <img src="../../../../assets/arrow.png" alt />
          </div>
          <div class="outreach" @click="fundraising">
            大病众筹
            <img src="../../../../assets/arrow.png" alt />
          </div> -->
          <div class="reportReadBox" v-if="getBrowserEnv()">
            <van-button type="primary" class="reportRead" v-if="!examidStorage.includes(infoData[0].exam_id) && infoData[0].report_interpret == '1'"  @click="goReportRead('fromReport')">报告解读</van-button>
            <wx-open-launch-weapp
              v-else-if="infoData[0].report_interpret == '1' && examidStorage.includes(infoData[0].exam_id)"
              id="launch-btn"
              appid="wx13a47ee9b472614f"
              :path='xcxurl'
              @launch="handleLaunch1"
              @error="handleError1"
            >
            <!-- /pages/home/index?scene=1&exam_id=`${infoData[0].exam_id}` -->
              <script type="text/wxtag-template">
                <style>
                  .reportRead1 {
                    width: 234px;
                    height: 44px;
                    padding: 5px 0;
                    border-radius: 50px;
                    margin: 20px auto 0;
                    color: #fff!important;
                    font-size: 16px!important;
                    border: 1px solid rgb(19, 172, 193);
                    background-color: rgb(19, 172, 193);
                  }
                </style>
                <button class="reportRead1">报告解读</button>
              </script>
            </wx-open-launch-weapp>
          </div>
      </footer>
    </div>
    <div class="inspectionMontmorillonite" v-if="Montmorillonite">
      <div class="inspectionInputBox">
        <div class="inspectionInputBoxPrompt">提示</div>
        <div class="inspectionInputBoxContent">
          <div class="inspectionInputBoxContentTitle">请输入4位密码查看{{xxx}}的检查报告</div>
          <div class="inspectionInputBoxContentPassword" style="padding-bottom: 8px;">
            输入密码：
            <input v-model="code" type="text" />
          </div>
          <div class="inspectionInputBoxError" v-if="passwordError">{{passwordError}}</div>
        </div>
        <div class="inspectionInputBoxButton">
          <span v-if="loading" class="passwordLoading">
            <van-loading size="20px" color="rgb(39, 172, 194)" />
            报告加载中...
          </span>
          <span v-else @click="cencelMontmorillonite">确定</span>
        </div>
      </div>
    </div>
    <!-- 查看分享报告 关注公众号二维码浮层 -->
    <!-- <div class="attentionQRCode" v-if="!forwardingReport"> -->
    <!-- <div style="display:flex">
        <img class="logo" src="../../../../assets/login.png" alt />
        <p style="font-size:14px">中世康恺</p>
      </div>
      <p :style="{fontSize:'12px'}">本服务由数字影像云提供，可关注公众号进一步了解详情</p>
      <img class="QRCodeImg" src="../../../../assets/QRcode.png" @click="show = true" alt />
    </div>-->
    <!-- 二维码弹窗 -->
    <van-overlay :show="show" @click="show = false">
      <div class="wrapper">
        <!--@click.stop-->
        <div class="block">
          <img class="modelQRCodeImg" src="../../../../assets/QRcode.png" />
          <p :style="{fontWeight:'bold',margin:'0px'}">公众号：数字影像云</p>
          <p :style="{fontSize:'12px',color:'#707270',margin:'5px 0'}">长按识别</p>
        </div>
      </div>
    </van-overlay>
     <!-- 检查详情报告解读 同意书弹窗 -->
     <van-dialog v-model="isOpenReadModel" title="三甲名医在线解读" :show-confirm-button="false">
      <van-icon name="cross" style="position: absolute;top: 15px;right: 15px;color:#909399;" @click="isOpenReadModel = false" />
      <div class="scrollBox">
        <div class="blocks">
          <p>✅支持所有检验和检查报告：核磁、CT、X线、血常规、尿常规、肾功、肝功、甲功等。</p>

          <p>✅支持咨询在线医生：饮食、运动和疾病预防等相关问题。</p>

          <p>👍专业、细致、耐心。</p>
          <!-- <div style="height:80px"></div> -->
           <div style="background: #fff;">
            <div style="margin: 10px 0;">
              <van-checkbox v-model="checked" shape="square" icon-size="12px" @change="changeHandle"/>
              <span style="margin-left:5px;color: rgb(19, 172, 193);">我已同意<span @click="goReadDetailModel()">《数字影像云报告解读服务知情同意书》</span></span>
            </div>
            <div style="width: 100%;"> 
              <!-- <button class="reportRead" @click="handleLaunch2">报告解读</button> -->
              <van-button type="primary" v-if="!checked" @click="goReportRead1">开始解读</van-button>
              <wx-open-launch-weapp
                  id="launch-btn2"
                  appid="wx13a47ee9b472614f"
                  :path="xcxurl"
                  @launch="handleLaunch2"
                  @error="handleError2"
                  v-else
                >
                  <script type="text/wxtag-template">
                    <style>
                      .reportRead1 {
                        width: 234px;
                        height: 44px;
                        padding: 5px 0;
                        border-radius: 50px;
                        color: #fff!important;
                        font-size: 16px!important;
                        border: 1px solid rgb(19, 172, 193);
                        background-color: rgb(19, 172, 193);
                      }
                    </style>
                    <button class="reportRead1">开始解读</button>
                  </script>
                </wx-open-launch-weapp>
            </div>
           </div>
           
        </div>
      </div>
    </van-dialog>
    <van-dialog v-model="isOpenReadDetailModel" title="数字影像云报告解读服务知情同意书" :show-confirm-button="false">
      <van-icon name="cross" style="position: absolute;top: 15px;right: 15px;color:#909399;" @click="isOpenReadDetailModel = false" />
      <div class="scrollDetailBox">
        <div class="blocks">
          <!-- <div>《数字影像云报告解读服务知情同意书》</div> -->
          <p>尊敬的患者/患者家属：</p>
          <p>
            您好！感谢您选择使用中世康恺科技有限公司提供的“数字影像云”公众号服务中的“报告
            解读”功能。为保障您的合法权益，确保您充分了解该服务的相关情况，特向您告知如下内
            容：
          </p>
          <p class="subTitle">一、服务内容</p>
          <p>“数字影像云”公众号服务中的“报告解读”功能由重庆君子务本科技有限公司提供。当您
点击“报告解读”按钮时，将跳转至重庆君子务本科技有限公司提供的报告解读服务页面。
该服务旨在通过专业的技术手段和医学知识，对您的医学影像报告进行解读，帮助您更好地
理解报告内容及检查结果。</p>
          <p class="subTitle">二、数据安全与隐私保护</p>
          <p>1.中世康恺科技有限公司和重庆君子务本科技有限公司均高度重视您的个人信息安全与隐
            私保护。您的影像资料及报告信息将通过加密技术进行传输与存储，确保数据的安全性。</p>
          <p>2.您的个人信息及报告解读结果仅用于为您提供医疗服务及必要的医疗咨询，不会用于其他任何商业用途。</p>
          <p>3.在服务过程中，如需将您的报告解读结果共享给其他医疗机构或专业人士，将事先征得您的明确同意。</p>
          <p class="subTitle">三、风险与限制</p>
          <p>1.报告解读服务是基于现有的医学知识和技术手段提供的辅助性解读，不能替代专业医生
            的面诊意见。最终的诊断和治疗方案应以医生的专业判断为准。</p>
            <p>2.由于医学的复杂性和个体差异，报告解读结果可能存在一定的局限性。在某些情况下，
              可能需要进一步的检查或诊断以确认病情。</p>
          <p>3.如您在使用报告解读服务过程中遇到任何问题或对解读结果有疑问，应及时咨询专业医
            生。</p>
            <p class="subTitle">四、费用说明</p>
            <p>重庆君子务本科技有限公司提供的报告解读服务可能涉及一定的费用。具体收费标准及支付
              方式将在服务页面进行明确说明。您在使用该服务前应仔细阅读相关费用说明，并确认同意
              支付相应费用。</p>
            <p class="subTitle">五、同意与授权</p>
            <p>1.您已充分了解上述内容，自愿选择使用“数字影像云”公众号服务中的“报告解读”功
能，并同意中世康恺科技有限公司将您的影像资料及报告信息传输给重庆君子务本科技有限
公司进行解读。</p>
          <p>2.您授权重庆君子务本科技有限公司及其授权的专业人员对您的影像资料及报告进行解读，
            并将解读结果提供给您。</p>
          <p>请您在确认同意以上内容后，点击“同意”按钮以继续使用“报告解读”服务。如果您不同
            意上述内容，可以选择不使用该服务。</p>
          <div style="height:20px"></div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import Storage from "@/tools/storage";
import { getAllReport, getPatientInfo, decodeSecretData, getReportBySecretExam } from "@/api/reportOuter";
import { getReportByCode, getOneReport, getReportInfo, getSaveInterpretLog } from "@/api/report";
import { wechatLogin } from "@/api/user";
import store from "@/store";
import QRCode from "qrcodejs2"; /* 生成二维码 */
import wx from "weixin-js-sdk";
import axios from "axios";
import commonFun from '@/tools/common'
import { Toast } from 'vant'
export default {
  name: "inspectionReport",
  props: ["Montmor"],
  data() {
    return {
      xxx: Storage.get("makeReportLinkName"),
      infoData: [],
      Montmorillonite: false,
      code: "",
      forwardingReport: true,
      examId: true,
      report: false,
      loading: true,
      awaitingPassword: false,
      errorMessage: "",
      passwordError: "",
      secretData: "",
      shareMeta: null,
      noreport: false,
      noreports: false,
      show: false,
      isAnonymous: 0,
      isEncrypt: 0,
      checked: true,
      isOpenReadModel: false,
      isOpenReadDetailModel: false,
      examidStorage: [],
      xcxurl: ''
    };
  },
  filters: {
    qzCode(id, url) {
      let text = url;
      let QrCodes = document.getElementById("qrcode" + id);
      let qrcode = new QRCode("qrcode", {
        width: 100,
        height: 100, // 高度
        text: text // 二维码内容
        // render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        // background: '#f0f'
        // foreground: '#ff0'
      });
      let obtainImg = QrCodes.getElementsByTagName("img");
      let obtainCanvas = QrCodes.getElementsByTagName("canvas");
      obtainImg[0].style.width = 1 + "rem";
      obtainImg[0].style.height = 1 + "rem";
      obtainCanvas[0].style.width = 1 + "rem";
      obtainCanvas[0].style.height = 1 + "rem";
    }
  },
  methods: {
    goReadDetailModel() {
      this.isOpenReadDetailModel = true
    },
    getBrowserEnv(){
      return commonFun.getBrowserEnv()
    },
    
    /* 判断是否有内容 */
    initial() {
      if (!!this.$route.query.short) {
        Storage.set("share", this.$route.query.short);
      }
      let shar = JSON.parse(Storage.get("share")) == null;
      if (shar) {
        const reportInfo = Array.isArray(this.infoData) ? this.infoData : [];
        let examId = reportInfo.length;
        if (!examId) {
          this.examId = false;
          this.report = false;
          this.loading = false;
          return;
        }
        getPatientInfo({
          exam_id: reportInfo[0].exam_id
        }).then(res => {
          if (Array.isArray(res) && res.length) {
            if (res[0].exam_status == 9 || res[0].report_status == 9) {
              this.report = true;
              this.noreport = true;
              this.noreports = false;
              this.creatQrCode(this.infoData);
            } else {
              this.report = false;
            }
          } else {
            this.report = false;
            this.noreport = false;
            this.noreports = true;
          }
          this.loading = false;
        });
      } 
      // else {
      //   this.report = true;
      //   this.noreport = true;
      //   this.noreports = false;
      // }
    },
    /* 二维码 */
    creatQrCode(data = this.infoData) {
      if (!Array.isArray(data) || !data.length) return;

      this.$nextTick(() => {
        data.forEach((item, index) => {
          const QrCodes = this.$el.querySelector("#qrcode" + index);
          if (!QrCodes || !item.qr_code) return;

          QrCodes.innerHTML = "";
          new QRCode(QrCodes, {
            width: 100,
            height: 100,
            text: item.qr_code
          });

          const obtainImg = QrCodes.getElementsByTagName("img")[0];
          const obtainCanvas = QrCodes.getElementsByTagName("canvas")[0];
          if (obtainImg) {
            obtainImg.style.width = "1rem";
            obtainImg.style.height = "1rem";
          }
          if (obtainCanvas) {
            obtainCanvas.style.width = "1rem";
            obtainCanvas.style.height = "1rem";
          }
        });
      });
    },
    insurance() {
      window.location.href = "http://leo.spread.newtank.cn/group0930";
    },
    fundraising() {
      window.location.href =
        "https://www.shuidichou.com/luban/f45t2je2sard/1?channel=ad_search_sem&source=app_zkwx";
    },
    toPortrait() {
      this.$router.push({ path: "/reportInfoOuter/portrait" });
    },
    toReportList() {
      this.$router.go(-1);
      // this.$router.push({ path: '/reportListOuter' })
    },
    onBack() {
      // this.$router.push({ path: '/filmQuery' })
      this.$router.go(-1);
    },
    toForwarding() {
      this.$router.push({ path: "/reportInfoOuter/forwarding" });
    },
    normalizeFlag(value) {
      return String(value) === "1" ? 1 : 0;
    },
    async initSecretLink() {
      this.loading = true;
      this.report = false;
      this.awaitingPassword = false;
      this.errorMessage = "";
      this.passwordError = "";

      const shareData = await decodeSecretData({ data: this.secretData });
      if (!shareData) {
        this.loading = false;
        this.errorMessage = "分享链接无效或已过期";
        return;
      }

      this.shareMeta = shareData;
      Storage.set("shareMeta", shareData);
      this.isEncrypt = this.normalizeFlag(
        shareData.isEncrypt !== undefined ? shareData.isEncrypt : shareData.encrypt
      );
      this.isAnonymous = this.normalizeFlag(
        shareData.isAnonymous !== undefined ? shareData.isAnonymous : shareData.anonymous
      );
      if (shareData.name !== undefined && shareData.name !== null) {
        this.xxx = shareData.name;
        Storage.set("makeReportLinkName", shareData.name);
      }
      this.$emit("secret-data-decoded", shareData);

      if (this.isEncrypt) {
        this.code = this.$route.query.pwd || "";
        this.awaitingPassword = true;
        this.loading = false;
        this.Montmorillonite = true;
        return;
      }

      this.Montmorillonite = false;
      await this.getSecretReport();
    },
    async getSecretReport() {
      this.loading = true;
      this.errorMessage = "";
      const params = { data: this.secretData };
      if (this.isEncrypt) {
        params.code = this.code;
      }

      const res = await getReportBySecretExam(params);
      if (res === null || res === undefined) {
        this.loading = false;
        this.report = false;
        if (this.isEncrypt) {
          this.awaitingPassword = true;
          this.Montmorillonite = true;
        } else {
          this.errorMessage = "报告查询失败";
        }
        return;
      }

      const reports = Array.isArray(res) ? res : [];
      if (reports.length) {
        Storage.set("reportInfo", reports);
        Storage.set("validatedSecretData", this.secretData);
        Storage.set("shareMeta", this.shareMeta || {});
        if (reports[0].study_id) {
          Storage.set("studyId", reports[0].study_id);
        }
        this.infoData = reports;
        this.report = true;
        this.awaitingPassword = false;
        this.Montmorillonite = false;
        this.loading = false;
        this.creatQrCode(reports);
        const scene = reports[0].scene || "1";
        this.xcxurl = "/pages/home/index?scene=" + scene + "&exam_id=" + reports[0].exam_id;
        return;
      }

      this.infoData = [];
      this.report = false;
      this.awaitingPassword = false;
      if (this.isEncrypt) {
        this.awaitingPassword = true;
        this.Montmorillonite = true;
      }
      this.loading = false;
    },
    async cencelMontmorillonite() {
      if (this.secretData) {
        this.passwordError = "";
        if (!this.code) {
          this.passwordError = "请输入访问密码";
          return;
        }
        await this.getSecretReport();
        if (!this.report) {
          this.passwordError = "验证码错误，请重新输入";
        }
        return;
      }

      this.loading = true;
      let params = { id: Storage.get("makeReportLinkId"), code: this.code, isEncrypt: this.isEncrypt,
          isAnonymous: this.isAnonymous };
      let res = await getReportByCode(params);
      if (Array.isArray(res) && res.length && (res[0].rid || res[0].id)) {
        Storage.set("reportInfo", res);
        Storage.set("studyId", res[0].study_id);
        Storage.set("validatedReportLinkId", params.id);
        this.infoData = res;
        this.report = true;
        this.loading = false;
        this.Montmorillonite = false;
        this.creatQrCode(res);
      } else {
        Storage.set("reportInfo", Array.isArray(res) ? res : []);
        if (Storage.get("validatedReportLinkId") == params.id) {
          Storage.del("validatedReportLinkId");
        }
        this.infoData = [];
        this.report = false;
        this.loading = false;
        this.Montmorillonite = false;
      }
    },
    // async wechatLogin(reportId) {
    //   console.log(Storage.get('openid'))
    //   let that = this
    //   let params = { openid: Storage.get('openid') }
    //   let res = await wechatLogin(params)
    //   if (res) {
    //     store.dispatch('setToken', res.token)
    //     that.getOneReport()
    //   }
    // },
    async getOneReport() {
      let params = { id: Storage.get("reportId") };
      let res = await getOneReport(params);
      if (res) {
        let arr = [];
        arr.push(res);
        this.infoData = arr;
        Storage.set("reportInfo", arr);
        Storage.set("studyId", res.study_id);
        this.report = true;
        this.loading = false;
        this.creatQrCode(arr);
      } else {
        this.report = false;
        this.loading = false;
      }
    },
    getIsEncryptFn(isEncrypt){
      return this.normalizeFlag(isEncrypt) === 1;
    },
    handleLaunch1(e) {
      this.reportReadRecord(1)
      console.log('跳转成功', e.detail);
    },
    handleError1(e) {
      this.reportReadRecord(1)
      console.error('跳转失败', e.detail);
    },
    handleLaunch2(e) {
      // this.reportReadRecord(2)
      const fromValue = Storage.get('fromValue')
      if(fromValue == 'fromList'){
        this.reportReadRecord(5)
      }else{
        this.reportReadRecord(2)
      }
      console.log('跳转成功', e.detail);
    },
    handleError2(e) {
      this.reportReadRecord(2)
      console.error('跳转失败', e.detail);
    },
    async reportReadRecord(type) {
      let res = await getSaveInterpretLog({
        id: this.infoData[0].exam_id,
        type,
        source: 2
      });
    },
    changeHandle(e) {
      console.log(e)
    },
    goReportRead(fromValue) {
      if(fromValue == 'fromReport'){
        Storage.set('fromValue', 'fromReport')
        this.reportReadRecord(1)
      }
      // this.reportReadRecord(1)
      const examidStorage = (this.examidStorage.length && this.examidStorage) || []
      if (!examidStorage.some(item => String(item) === String(this.infoData[0].exam_id))) {
        this.examidStorage.push(String(this.infoData[0].exam_id)); // 保留原始类型
        Storage.set('examid', this.examidStorage)
        this.isOpenReadModel = true
      }else{
        this.isOpenReadModel = false
      }
    },
    goReportRead1() {
      Toast('请先勾选我已同意')
    },
    initSdkConfig() {
      axios
        .post("https://wechat.pacsonline.cn/wx_patient/api/getJsSdkConfig")
        .then(res => {
          wx.config({
            debug: false,
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ['scanQRCode'],
            openTagList: ['wx-open-launch-weapp']
          });
        });
    },
  },
  mounted() {
    if (this.secretData) {
      return;
    }
    this.initial();
    if (this.report && this.infoData.length) {
      this.creatQrCode(this.infoData);
    }
  },
  created() {
    const query = this.$route.query || {};
    const url = window.location.href;
    this.isEncrypt = query.isEncrypt === undefined && query.short
      ? 1
      : this.normalizeFlag(query.isEncrypt);
    this.isAnonymous = this.normalizeFlag(query.isAnonymous);
    this.examidStorage = JSON.parse(Storage.get('examid')) || [];
    this.infoData = JSON.parse(Storage.get('reportInfo')) || [];

    if (query.data) {
      this.secretData = query.data;
      Storage.set("reportPermissions", 1);
      this.forwardingReport = false;

      // tab 切换会重新创建组件。当前安全链接已经验证过时，直接恢复报告，
      // 避免再次解密并弹出密码框；换了链接则清理上一条链接的报告缓存。
      const validatedSecretData = Storage.get("validatedSecretData");
      const cachedReports = this.infoData;
      let cachedShareMeta = null;
      try {
        cachedShareMeta = JSON.parse(Storage.get("shareMeta") || "null");
      } catch (error) {
        cachedShareMeta = null;
      }
      const hasCachedReport =
        validatedSecretData === this.secretData &&
        cachedShareMeta &&
        Array.isArray(cachedReports) &&
        cachedReports.length > 0;

      if (hasCachedReport) {
        this.shareMeta = cachedShareMeta;
        this.isEncrypt = this.normalizeFlag(
          cachedShareMeta && cachedShareMeta.isEncrypt !== undefined
            ? cachedShareMeta.isEncrypt
            : cachedShareMeta && cachedShareMeta.encrypt
        );
        this.isAnonymous = this.normalizeFlag(
          cachedShareMeta && cachedShareMeta.isAnonymous !== undefined
            ? cachedShareMeta.isAnonymous
            : cachedShareMeta && cachedShareMeta.anonymous
        );
        if (cachedShareMeta && cachedShareMeta.name !== undefined && cachedShareMeta.name !== null) {
          this.xxx = cachedShareMeta.name;
        }
        this.report = true;
        this.awaitingPassword = false;
        this.Montmorillonite = false;
        this.loading = false;
        const currentReport = cachedReports[0];
        const scene = currentReport.scene || "1";
        this.xcxurl = "/pages/home/index?scene=" + scene + "&exam_id=" + currentReport.exam_id;
        this.$emit("secret-data-decoded", cachedShareMeta || {});
        return;
      }

      Storage.set("reportInfo", []);
      Storage.del("validatedSecretData");
      Storage.del("shareMeta");
      Storage.del("validatedReportLinkId");
      Storage.del("makeReportLinkId");
      Storage.del("makeReportLinkName");
      this.xxx = "";
      this.infoData = [];
      this.report = false;
      this.loading = true;
      this.initSecretLink();
      return;
    }

    if (url.indexOf("report_id=") != -1) {
      let reportId = url.match(/id=(\S*)&openid/)[1];
      let string = url.indexOf("openid=");
      let names = url.substring(string);
      let num = names.indexOf("=");
      let name = names.substring(num + 1);
      Storage.set("openid", name);
      Storage.set("reportId", reportId);
      this.getOneReport();
    }
    if (url.indexOf("short=1") != -1) {
      let currentShareId = "";
      if (url.indexOf("short=1") != -1 && url.indexOf("id=") != -1) {
        currentShareId = url.match(/id=(\S*)&short/)[1];
        Storage.set("makeReportLinkId", currentShareId);
        const nameMatch = url.match(/[?&]name=([^&]*)/);
        if (nameMatch) {
          try {
            const reportName = decodeURIComponent(nameMatch[1]);
            Storage.set("makeReportLinkName", reportName);
            this.xxx = reportName;
          } catch (error) {
            console.warn("分享链接中的姓名解析失败", error);
          }
        }

        const currentReport = this.infoData[0];
        const hasCachedReport = Boolean(currentReport && (currentReport.id || currentReport.rid));
        const isCurrentLinkValidated =
          Storage.get("validatedReportLinkId") == currentShareId;
        this.report = hasCachedReport && isCurrentLinkValidated;
        this.loading = !this.report;
      }
      Storage.set("reportPermissions", 1);
      const isCurrentLinkValidated =
        currentShareId && Storage.get("validatedReportLinkId") == currentShareId;
      if (isCurrentLinkValidated || !this.getIsEncryptFn(this.isEncrypt)) {
        this.Montmorillonite = false;
        if (!isCurrentLinkValidated && !this.getIsEncryptFn(this.isEncrypt)) {
          this.cencelMontmorillonite()
        }
      } else {
        this.Montmorillonite = true;
      }
    } else {
      this.Montmorillonite = false;
    }

    if (Storage.get("reportPermissions")) {
      this.forwardingReport = false;
    }
    const currentReport = this.infoData[0];
    if (currentReport) {
      const scene = currentReport.scene || '1'
      this.xcxurl = '/pages/home/index?scene='+ scene +'&exam_id=' + currentReport.exam_id
    }
  }
};
</script>
<style lang="sass" scoped>
@import "../../../../style/reportInfo/index.css"
</style>
<style scoped>
.van-checkbox {
  display: inline-block!important;
}
.reportReadBox {
  width: 100%;
  text-align: center;
  position: fixed;
  bottom: 10px;
}
.reportRead {
  width: 50%!important;
  margin-top: 20px;
  font-size: 16px!important;
}
.van-button--primary{
  border: 1px solid rgb(19, 172, 193);
  background-color: rgb(19, 172, 193);
}
.van-button__text{
  color: #fff!important;
}
.white_title {
  height: 100vh;
  line-height: 100vh;
  font-size: 20px;
  text-align: center;
}
.reportLoading {
  min-height: calc(100vh - 55px);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #606266;
}
.passwordLoading {
  display: flex !important;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.inspectionInputBoxError {
  margin: 0 0 8px 0;
  color: #f56c6c;
  font-size: 12px;
  text-align: center;
}
.header {
  position: relative;
}
.white_QR {
  position: absolute;
  top: 0.4rem;
  right: 0;
}
.attentionQRCode .logo {
  width: 26px;
  height: 26px;
  display: inline-block;
  margin-right: 8px;
}
.attentionQRCode p {
  margin: 0;
}
.attentionQRCode .QRCodeImg {
  width: 80px;
  height: 80px;
  position: absolute;
  right: 25px;
  bottom: 40px;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 16px;
}
.block {
  width: 240px;
  height: 240px;
  background-color: #fff;
  text-align: center;
}
.wrapper .modelQRCodeImg {
  width: 150px;
  height: 150px;
  margin-top: 20px;
}
.scrollBox {
  width: 80%;
  /* height: 400px; */
  margin: 0 auto;
  padding: 20px;
  background: #ffffff;
}
.scrollDetailBox {
  width: 80%;
  height: 300px;
  overflow-y: scroll;
  margin: 0 auto;
  padding: 20px;
  background: #ffffff;
}
.blocks::-webkit-scrollbar {
  display: none;
}
.blocks {
  height: 100%;
  border-radius: 10px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  /* padding: 10px; */
}
.blocks div {
  font-size: 14px;
  text-align: center;
  font-weight: bold;
}
.blocks p {
  text-align: left;
  text-indent: 2em;
}
.blocks .subTitle {
  font-weight: bold;
}
</style>
